import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function RankingContent() {
  const [rankingData, setRankingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userID = localStorage.getItem('userID');
  const selectedSimuladoID = localStorage.getItem('selectedSimuladoID'); // ID do simulado selecionado
  const [simuladoDate, setSimuladoDate] = useState('');
  const [groupRankingData, setGroupRankingData] = useState([]);

  const [simuladoMediaGeral, setSimuladoMediaGeral] = useState(null);
  const [simuladoMediaGrupo, setSimuladoMediaGrupo] = useState(null);

  const [userRankingData, setUserRankingData] = useState(null);

  
const roundToOneDecimal = (number) => {
  if (number === null || number === undefined ||number === 0) return '-';
  return Number(number).toFixed(1)
};

  useEffect(() => {
    const fetchGroupRankingData = async () => {
      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=ranking&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.json();
        console.log('group ranking data: ', data)
        
        // Parse do ranking por grupo do JSON retornado
        const groupRanking = data.group_ranking ? JSON.parse(data.group_ranking) : [];
        setGroupRankingData(groupRanking); // Define os dados do ranking por grupo
      } catch (err) {
        console.error('Erro ao buscar ranking por grupo:', err);
      }
    };
  
    if (selectedSimuladoID && userID) {
      fetchGroupRankingData();
    }
  }, [selectedSimuladoID, userID]);
  

  useEffect(() => {
    const fetchSimuladoDate = async () => {
        try {
            const responseSimulado = await fetch(`https://rvensino.com.br/get.php?action=get_simulados_by_aluno&ID_aluno=${userID}`);
            const simuladoData = await responseSimulado.json();
            console.log('simulado data: ', simuladoData)

            // Extrai os dados do simulado
            const simuladosData = simuladoData.simulado_IDs.map((id, index) => ({
                id,
                date: simuladoData.simulado_datas[index],
            }));

            let selectedSimulado;
            
            if (selectedSimuladoID) {
                selectedSimulado = simuladosData.find(simulado => simulado.id === selectedSimuladoID);
            }

            if (!selectedSimulado) {
                selectedSimulado = simuladosData[simuladosData.length - 1];
                localStorage.setItem('selectedSimuladoID', selectedSimulado.id);
            }

            setSimuladoDate(selectedSimulado.date);
        } catch (error) {
            console.error('Erro ao buscar a data do simulado:', error);
        }
    };

    if (userID) {
        fetchSimuladoDate();
    }
}, [userID, selectedSimuladoID]);


  useEffect(() => {
    const fetchRankingData = async () => {
      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=ranking&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.json();
        console.log('ranking data: ', data) 

        // Parse do ranking geral do JSON retornado
        const overallRanking = data.overall_ranking ? JSON.parse(data.overall_ranking) : [];
        setRankingData(overallRanking); // Define os dados do ranking geral
      } catch (err) {
        setError(err.message);
        console.error('Erro ao buscar ranking:', err);
      } finally {
        setLoading(false);
      }
    };

    if (selectedSimuladoID && userID) {
      fetchRankingData();
    }
  }, [selectedSimuladoID, userID]);


  // dá erro aqui
  useEffect(() => {
    const fetchMediaData = async () => {
      try {
        if (!selectedSimuladoID) return;
  
        // Requisição da média geral do simulado
        const responseGeral = await fetch(`https://rvensino.com.br/get.php?action=get_media_simulado&ID_simulado=${selectedSimuladoID}`);
        const dataGeral = await responseGeral.json();
        setSimuladoMediaGeral(dataGeral);
        console.log('media geral data: ', dataGeral)
  
        // Requisição da média do grupo
        const responseGrupo = await fetch(`https://rvensino.com.br/get.php?action=get_media_simulado_by_group&ID_simulado=${selectedSimuladoID}&grupo=4`);
        const dataGrupo = await responseGrupo.json();
        setSimuladoMediaGrupo(dataGrupo);
        console.log('media grupo data: ', dataGrupo)
        
      } catch (error) {
        console.error("Erro ao buscar as médias:", error);
      }
    };
  
    fetchMediaData();
  }, [selectedSimuladoID]); 

  useEffect(() => {
    const fetchUserRankingData = async () => {
      if (!userID || !selectedSimuladoID) return;
  
      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=ranking&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.json();
        console.log('user ranking data: ', data)
  
        if (data) {
          setUserRankingData(data);
        }
      } catch (err) {
        console.error('Erro ao buscar dados do ranking do usuário:', err);
      }
    };
  
    fetchUserRankingData();
  }, [userID, selectedSimuladoID]);
  
  


  if (loading) {
    // return <div className="loading">...</div>;
    return <div className='page-container'> <div className='empty'>Seus dados de ranking aparecerão aqui </div> </div>;
    // colocar animação no ...
  }

  if (!rankingData) {
    return <div className='page-container'> <div className='empty'>Seus dados de ranking aparecerão aqui </div> </div>;
  }

  

  if (error) {
    return <div className='page-container'> <div className='empty'>Seus dados de ranking aparecerão aqui </div> </div>;
    // return <div className="error">Erro ao carregar dados de ranking</div>;
  }

  return (
    <div className="ranking-container">

      <div className='ranking-info'>
        <div className='exam dashboard-link ranking'>
            <Link to="/historico" className="no-link-style"> Simulado realizado em {simuladoDate} </Link>
        </div>
      </div>

    {/* colocar 10 */}
      <div className='ranking-details-container'>
          <div className="ranking">

            <div className='ranking-geral'>
            <h3 className='ranking-page-title'>Ranking geral</h3>

            <div className="ranking-table">
  <table>
  <thead>
    <tr>
      <th className="ranking-header"></th>
      <th className="ranking-header">CN</th>
      <th className="ranking-header"></th>
      <th className="ranking-header">MT</th>
      <th className="ranking-header"></th>
      <th className="ranking-header geral">GERAL</th>
    </tr>
  </thead>
    <tbody>
      {rankingData.map((data, index) => {
        // Divide o nome completo e mantém apenas primeiro e último nome
        const nameParts = data.nome.split(" ");
        const formattedName =
          nameParts.length > 1
            ? `${nameParts[0]} ${nameParts[nameParts.length - 1]}`
            : data.nome;

        return (
          <tr key={index} className="ranking-details">
            <td className="rank-content">
              <div className="ranking-name">
                <div className="posicao-circle">
                  <p>{`${data.posicao_geral}º`}</p>
                </div>
                <span className="nome">{formattedName}</span>
              </div>
            </td>
            <td className='position'>{data.posicao_natureza}º </td>
            <td className='grade'>| {roundToOneDecimal(data.nota_natureza)}</td>
            <td className='position'>{data.posicao_matematica}º</td>
            <td className='grade'>| {roundToOneDecimal(data.nota_matematica)}</td>
            <td>{roundToOneDecimal(data.nota_geral_sem_redacao)}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>




              


            </div>

          <div className="divide-line"></div>

            {/* position fixed, nota do aluno sempre fica fixa na tela e scroll é na lista dos demais se for necessário */}
            {userRankingData && (
              <div className="ranking-details">
                <div className="ranking-line">
                  <div className="ranking-entry">
                    <div className="posicao-circle">
                      <p>{`${userRankingData.overall_position}º`}</p>
                    </div>
                    <div className="rank-content">
                      <div className="rank-values">
                        <p className="nome">{userRankingData.name}</p>
                        <p>
                          {userRankingData.CN_position}º | {roundToOneDecimal(userRankingData.CN_grade)}
                        </p>
                        <p>
                          {userRankingData.MT_position}º | {roundToOneDecimal(userRankingData.MT_grade)}
                        </p>
                        <p>{roundToOneDecimal(userRankingData.overall_grade)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}


          </div>

        <div className='ranking-data-container'>



            <div className="ranking-data group">
            <h3 className='ranking-page-title grupo'>Ranking por grupo</h3>
            <div className="ranking-table details">
  <table>
  <thead>
    <tr>
      <th className="ranking-header"></th>
      <th className="ranking-header">CN</th>
      <th className="ranking-header"></th>
      <th className="ranking-header">MT</th>
      <th className="ranking-header"></th>
      <th className="ranking-header geral">GERAL</th>
    </tr>
  </thead>
    <tbody>

      
      {groupRankingData.map((data, index) => {
        const nameParts = data.nome.split(" ");
        const formattedName =
          nameParts.length > 1
            ? `${nameParts[0]} ${nameParts[nameParts.length - 1]}`
            : data.nome;

        return (
          <tr key={index} className="ranking-details">
            <td className="rank-content">
              <div className="ranking-name">
                <div className="posicao-circle">
                  <p>{`${data.posicao_grupo}º`}</p>
                </div>
                <span className="nome">{formattedName}</span>
              </div>
            </td>

            <td className='position'>{data.posicao_natureza}º </td>
            <td className='grade'>| {roundToOneDecimal(data.nota_natureza)}</td>


            <td className='position'>{data.posicao_matematica}º</td>
            <td className='grade'>| {roundToOneDecimal(data.nota_matematica)}</td>


            <td>{roundToOneDecimal(data.nota_geral_sem_redacao)}</td>
          </tr>
        );
      })}


    </tbody>
  </table>


  
</div>

<div className="divide-line"></div>

            {/* position fixed, nota do aluno sempre fica fixa na tela e scroll é na lista dos demais se for necessário */}
            {userRankingData && (
  <div className="ranking-details group">
    <div className="ranking-line">
      <div className="ranking-entry">
        <div className="posicao-circle">
          <p>{`${userRankingData.group_position}º`}</p>
        </div>
        <div className="rank-content">
          <div className="rank-values">
            <p className="nome">{userRankingData.name}</p>
            <p>
              {userRankingData.CN_position}º | {roundToOneDecimal(userRankingData.CN_grade)}
            </p>
            <p>
              {userRankingData.MT_position}º | {roundToOneDecimal(userRankingData.MT_grade)}
            </p>
            <p>{roundToOneDecimal(userRankingData.overall_grade)}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

            </div>


            <div className="ranking-data media">
              <h3 className='ranking-page-title media'>Sua média</h3>
              <div className='info'>
                <p className='info-card-note'> {roundToOneDecimal(userRankingData?.overall_grade)} </p>
                <p className='info-card-text'>Média sem redação </p>
              </div>
              <div className='info'>
                <p className='info-card-note'> - </p>
                <p className='info-card-text'>Média com redação </p>
              </div>
            </div>

            <div className="ranking-data media">
              <h3 className='ranking-page-title media'>Média dos candidatos</h3>
              <div className='info'>
                <p className='info-card-note'>{roundToOneDecimal(userRankingData?.exam_mean)}</p>
                <p className='info-card-text'>Média sem redação</p>
              </div>
              <div className='info'>
                <p className='info-card-note'>-</p>
                <p className='info-card-text'>Média com redação</p>
              </div>
            </div>

            <div className="ranking-data media">
              <h3 className='ranking-page-title media'>Média do seu grupo</h3>
              <div className='info'>
                <p className='info-card-note'>{roundToOneDecimal(userRankingData?.exam_group_mean)}</p>
                <p className='info-card-text'>Média sem redação</p>
              </div>
              <div className='info'>
                <p className='info-card-note'>-</p>
                <p className='info-card-text'>Média com redação</p>
              </div>
            </div>

            


            
        </div>

      </div>




    </div>
  );
}

export default RankingContent;